import request from 'superagent';

class InfoStore {
  constructor() {
    this.addListener = this.addListener.bind(this);
    this.removeListener = this.removeListener.bind(this);
    this.setFrom = this.setFrom.bind(this);
    this.setTo = this.setTo.bind(this);
    this.setPair = this.setPair.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.refresh = this.refresh.bind(this);
    this.onChangeFunctions = [];

    this.loaded = false;
    this.announcements = [];
    this.fromCoin = null;
    this.toCoin = null;
    this.provider = null;
    this.rate = null;
    this.min = null;
    this.max = null;
    this.minerFee = null;

    setTimeout(this.refresh, 60 * 1000);
  }

  addListener(func) {
    this.onChangeFunctions.push(func);
  }

  removeListener(func) {
    for (let i = 0, l = this.onChangeFunctions.length; i < l; i += 1) {
      if (this.onChangeFunctions[i] === func) {
        this.onChangeFunctions.splice(i, 1);
        break;
      }
    }
  }

  refresh() {
    if (!this.loaded || this.fromCoin === null || this.toCoin === null) {
      return setTimeout(this.refresh, 60 * 1000);
    }
    return this.getInfo((error) => {
      if (error) console.log(error);
      setTimeout(this.refresh, 60 * 1000);
    });
  }

  setFrom(coin, callback) {
    this.loaded = false;
    if (this.toCoin.id === coin.id) this.toCoin = this.fromCoin;
    this.fromCoin = coin;
    this.getInfo(callback);
  }

  setTo(coin, callback) {
    this.loaded = false;
    if (this.fromCoin.id === coin.id) this.fromCoin = this.toCoin;
    this.toCoin = coin;
    this.getInfo(callback);
  }

  setPair(fromCoin, toCoin, callback) {
    this.loaded = false;
    this.fromCoin = fromCoin;
    this.toCoin = toCoin;
    this.getInfo(callback);
  }

  getInfo(callback) {
    request
      .get(`${process.env.REACT_APP_API_URL}/public/info/${this.fromCoin.symbol}_${this.toCoin.symbol}`)
      .accept('json')
      .end((error, response) => {
        if (error) return callback(error.message);
        if (response.body.status !== 'success') return callback(response.body.message);

        this.announcements = response.body.data.announcements;
        this.provider = response.body.data.provider;
        this.rate = response.body.data.rate;
        this.min = response.body.data.min;
        this.max = response.body.data.max;
        this.minerFee = response.body.data.minerFee;

        this.loaded = true;

        this.onChangeFunctions.forEach((func) => {
          func();
        });

        return callback(false);
      });
  }
}

export default InfoStore;



// WEBPACK FOOTER //
// ./src/stores/Info.js